import { modifier } from 'ember-modifier';
import Constants from '../utils/constants';

/**
 * Toggle a QA Attribute between different elements depending on which one has the provided toggleClass
 * toggleClass: The element(s) that have this class will be given the QA Attribute
 * attrText: The unique text that should be assigned for the attribute
 * toggleValue: will determine when the modifier renders
 */
export default modifier(
    function toggleQaAttr(element, properties, { toggleClass, attrText, toggleValue }) {
        let setQAAttr = () => element.setAttribute(Constants.QA_ATTR_NAME, `${Constants.QA_ATTR_PREFIX}_${attrText}`),
            removeQAAttr = () => element.removeAttribute(Constants.QA_ATTR_NAME);

        if (!toggleClass) {
            // Toggle based on toggleValue
            if (toggleValue) setQAAttr();
            else removeQAAttr();
        } else {
            // Toggle based on class
            if (Object.values(element.classList).includes(toggleClass)) setQAAttr();
            else removeQAAttr();
        }
    },
    { eager: false },
);
